import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { ProductContext } from "../../store";

const DEFAULT_REPORTS_PATH = "/search/dashboard";

const WebsiteIdentityCell = ({
	websiteId,
	websiteUrl,
	companyName,
	reportsPath = DEFAULT_REPORTS_PATH,
}) => {
	const navigate = useNavigate();
	const { selectWebsiteForAdmin } = useContext(ProductContext);

	const href = websiteUrl?.startsWith("http") ? websiteUrl : `https://${websiteUrl}`;
	const displayName =
		companyName?.trim() ||
		websiteUrl?.trim() ||
		`Website ${websiteId}`;
	const showUrlLine =
		Boolean(websiteUrl?.trim()) && websiteUrl.trim() !== displayName;

	const openWebsiteReports = (event) => {
		event.preventDefault();
		if (!websiteId) {
			return;
		}

		selectWebsiteForAdmin(
			websiteId
		);
		navigate(reportsPath);
	};

	return (
		<td className="websiteIdentityCell">
			<a
				href={reportsPath}
				onClick={openWebsiteReports}
				className="websiteCompanyName websiteCompanyLink"
				title="Open website reports"
			>
				{displayName}
			</a>
			{showUrlLine ? (
				<a
					href={href}
					target="_blank"
					rel="noopener noreferrer"
					className="websiteUrl"
				>
					{websiteUrl}
				</a>
			) : !websiteUrl?.trim() ? (
				<span className="websiteUrl text-muted">—</span>
			) : null}
		</td>
	);
};

export default WebsiteIdentityCell;
